import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import IESCourses from './section-components/IES-details';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";

const IES = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>IES Coaching Institute Chennai | Online, Offline, Hybrid Classes | MIET</title>
            <meta name="description" content="MIET is a premier institute which provides coaching in IES, IAS, TET, TNPSC and other competitive exams. Contact us to know more about our faculties&courses." />
        </Helmet>
        <PageHeader headertitle="IES"  />
        <IESCourses />
        <Footer />
    </div>
}

export default IES